export default function OsobaModal({
	isOpen,
	editingItem,
	formImieINazwisko,
	setFormImieINazwisko,
	formFunkcja,
	setFormFunkcja,
	formTelefon,
	setFormTelefon,
	formEmail,
	setFormEmail,
	formPlacowkaId,
	formPlacowkaName,
	onOpenPlacowkaSelect,
	isSaving,
	onClose,
	onSubmit,
}) {
	if (!isOpen) return null

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center p-4">
			<div className="absolute inset-0 bg-black/40" onClick={onClose} />
			<div className="relative w-full max-w-md rounded-lg bg-white shadow-xl">
				<form onSubmit={onSubmit} className="p-5">
					<h3 className="text-base font-semibold text-gray-900">
						{editingItem ? 'Edytuj osobe' : 'Dodaj osobe'}
					</h3>
					<p className="mt-1 text-sm text-gray-500">
						{editingItem ? 'Zaktualizuj dane osoby.' : 'Wprowadz dane nowej osoby.'}
					</p>

					<div className="mt-4">
						<label htmlFor="osoba-imie-i-nazwisko" className="block text-sm font-medium text-gray-700">
							Imie i nazwisko
						</label>
						<input
							id="osoba-imie-i-nazwisko"
							type="text"
							value={formImieINazwisko}
							onChange={e => setFormImieINazwisko(e.target.value)}
							required
							autoFocus
							className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
						/>
					</div>

					<div className="mt-4">
						<label htmlFor="osoba-funkcja" className="block text-sm font-medium text-gray-700">
							Funkcja
						</label>
						<input
							id="osoba-funkcja"
							type="text"
							value={formFunkcja}
							onChange={e => setFormFunkcja(e.target.value)}
							required
							className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
						/>
					</div>

					<div className="mt-4">
						<label htmlFor="osoba-telefon" className="block text-sm font-medium text-gray-700">
							Telefon
						</label>
						<input
							id="osoba-telefon"
							type="text"
							value={formTelefon}
							onChange={e => setFormTelefon(e.target.value)}
							required
							className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
						/>
					</div>

					<div className="mt-4">
						<label htmlFor="osoba-email" className="block text-sm font-medium text-gray-700">
							Email
						</label>
						<input
							id="osoba-email"
							type="email"
							value={formEmail}
							onChange={e => setFormEmail(e.target.value)}
							className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
						/>
					</div>

					<div className="mt-4">
						<div className="flex items-center justify-between">
							<label className="block text-sm font-medium text-gray-700">Placowka</label>
							<button
								type="button"
								onClick={onOpenPlacowkaSelect}
								className="rounded-md border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50">
								Wybierz z listy
							</button>
						</div>
						<div className="mt-1 min-h-10 rounded-md border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-700">
							{formPlacowkaId ? formPlacowkaName || formPlacowkaId : 'Nie wybrano placowki'}
						</div>
					</div>

					<div className="mt-5 flex justify-end gap-2">
						<button
							type="button"
							onClick={onClose}
							className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
							Anuluj
						</button>
						<button
							type="submit"
							disabled={
								isSaving ||
								!formImieINazwisko.trim() ||
								!formFunkcja.trim() ||
								!formTelefon.trim() ||
								!formPlacowkaId
							}
							className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-400">
							{isSaving ? 'Zapisywanie...' : editingItem ? 'Zapisz zmiany' : 'Utworz'}
						</button>
					</div>
				</form>
			</div>
		</div>
	)
}
